export const isProduction = process.env.NODE_ENV === "production";

export const apiBaseUrl = isProduction
	? "https://24food-api.azurewebsites.net/api"
	: "https://24food-api-dev.azurewebsites.net/api";
